import { useEffect, useRef, useState } from 'react';
import { ApiErrorResponse, CASH_DISCREPANCY_NOT_CONFIRMED } from '../../services/apiError';

/**
 * Confirmación de discrepancia al tomar o dejar la caja. El backend rechaza la operación con
 * CASH_DISCREPANCY_NOT_CONFIRMED si el monto declarado no coincide y falta `acceptDiscrepancy`.
 * Mientras está `pending`, el modal muestra la confirmación en lugar del formulario.
 */
export default function useCashDiscrepancyConfirmation() {
    const [pending, setPending] = useState(false);
    const [focusRequested, setFocusRequested] = useState(false);
    const declaredAmountRef = useRef<HTMLInputElement>(null);

    // Al volver a revisar, el input se monta de nuevo: el foco se pide recién después del render
    useEffect(() => {
        if (!focusRequested) return;
        declaredAmountRef.current?.focus();
        declaredAmountRef.current?.select();
        setFocusRequested(false);
    }, [focusRequested]);

    /** Devuelve true si el error es la discrepancia sin confirmar; en ese caso queda pendiente de decisión. */
    const handleRejection = (apiError: ApiErrorResponse): boolean => {
        if (apiError.errorCode !== CASH_DISCREPANCY_NOT_CONFIRMED) return false;
        setPending(true);
        return true;
    };

    /** Vuelve al formulario con el foco en el monto declarado. */
    const review = () => {
        setPending(false);
        setFocusRequested(true);
    };

    const reset = () => setPending(false);

    return { pending, declaredAmountRef, handleRejection, review, reset };
}
